import { useEffect } from "react";

const EachPageEachSignatory = ({
  containerRef,
  signatories = [],
  dropX,
  dropY,
  label = "Signature",
  setSignatureFields,
  setSelectedField,
  setModePayload,
}) => {
  useEffect(() => {
    const existingPageCount = containerRef.current.children.length;
    const newFields = [];

    signatories.forEach((signatory, idx) => {
      const fieldId = Date.now() + Math.random();
      let pageContainer;

      // Step 1: Use existing pages first
      if (idx < existingPageCount) {
        pageContainer = containerRef.current.children[idx];
      } else {
        const blankPageIndex = containerRef.current.children.length;

        const blankPage = document.createElement("div");
        blankPage.className = "pdf-page";
        blankPage.style.position = "relative";
        blankPage.style.width = "595px";
        blankPage.style.height = "842px";
        blankPage.style.backgroundColor = "#fff";
        blankPage.style.border = "1px solid #ccc";
        blankPage.style.margin = "10px auto";

        const blankTextLayer = document.createElement("div");
        blankTextLayer.className = "textLayer";
        blankTextLayer.style.position = "absolute";
        blankTextLayer.style.top = 0;
        blankTextLayer.style.left = 0;
        blankTextLayer.style.right = 0;
        blankTextLayer.style.bottom = 0;

        const pageNumber = document.createElement("div");
        pageNumber.innerText = `Page ${blankPageIndex + 1}`;
        pageNumber.style.position = "absolute";
        pageNumber.style.bottom = "10px";
        pageNumber.style.right = "10px";
        pageNumber.style.fontSize = "12px";
        pageNumber.style.color = "#000";

        blankPage.appendChild(blankTextLayer);
        blankPage.appendChild(pageNumber);
        containerRef.current.appendChild(blankPage);

        pageContainer = blankPage;
      }

      // Ensure textLayer exists (even for existing pages)
      let textLayerDiv = pageContainer.querySelector(".textLayer");
      if (!textLayerDiv) {
        textLayerDiv = document.createElement("div");
        textLayerDiv.className = "textLayer";
        textLayerDiv.style.position = "absolute";
        textLayerDiv.style.top = 0;
        textLayerDiv.style.left = 0;
        textLayerDiv.style.right = 0;
        textLayerDiv.style.bottom = 0;
        pageContainer.appendChild(textLayerDiv);
      }
      const wrapper = document.createElement("div");
      wrapper.style.position = "absolute";
      wrapper.style.left = `60px`;
      wrapper.style.top = `100px`;
      wrapper.style.display = "flex";
      wrapper.style.alignItems = "center";
      wrapper.style.gap = "8px";
      wrapper.style.cursor = "move";

      const nameDiv = document.createElement("div");
      nameDiv.innerText = signatory.name;
      nameDiv.style.fontWeight = "bold";

      const field = document.createElement("div");
      field.innerText = "Signature";
      field.contentEditable = true;
      field.style.padding = "4px 8px";
      field.style.border = "1px solid #666";
      field.style.backgroundColor = "#f9f9f9";
      field.style.borderRadius = "4px";
      field.style.fontSize = "14px";
      field.style.fontFamily = "Arial";
      field.style.color = "#000";

      const deleteIcon = document.createElement("span");
      deleteIcon.innerHTML = "❌";
      deleteIcon.style.cursor = "pointer";
      deleteIcon.style.fontSize = "12px";
      deleteIcon.title = "Delete Field";
      deleteIcon.addEventListener("click", () => wrapper.remove());

      const editIcon = document.createElement("span");
      editIcon.innerHTML = "✏️";
      editIcon.style.cursor = "pointer";
      editIcon.style.fontSize = "12px";
      editIcon.title = "Edit Field";
      editIcon.addEventListener("click", () => setSelectedField(field));

      const saveIcon = document.createElement("span");
      saveIcon.innerHTML = "✅";
      saveIcon.style.cursor = "pointer";
      saveIcon.style.fontSize = "12px";
      saveIcon.title = "Save Position";
      saveIcon.addEventListener("click", () => {
        wrapper.style.cursor = "default";
        field.contentEditable = false;

        const newX = parseFloat(wrapper.style.left);
        const newY = parseFloat(wrapper.style.top);

        setSignatureFields((prev) =>
          prev.map((f) =>
            f.id === fieldId ? { ...f, x: newX, y: newY, saved: true } : f,
          ),
        );

        [saveIcon, deleteIcon, editIcon].forEach((icon) => {
          if (icon && icon.parentNode) icon.parentNode.removeChild(icon);
        });

        field.removeEventListener("mousedown", onMouseDownHandler);
      });

      let isDragging = false;
      let offsetX = 0;
      let offsetY = 0;

      const onMouseMove = (e) => {
        if (!isDragging) return;
        const parentRect = textLayerDiv.getBoundingClientRect();
        const newX = e.clientX - parentRect.left - offsetX;
        const newY = e.clientY - parentRect.top - offsetY;
        wrapper.style.left = `${newX}px`;
        wrapper.style.top = `${newY}px`;
      };

      const onMouseUp = () => {
        isDragging = false;
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);

        // ✅ Update fieldData position in signatureFields state
        const newX = parseFloat(wrapper.style.left);
        const newY = parseFloat(wrapper.style.top);

        setSignatureFields((prevFields) =>
          prevFields.map((f) => {
            if (f.id === fieldId) {
              return {
                ...f,
                x: newX,
                y: newY,
              };
            }
            return f;
          }),
        );
      };

      const onMouseDownHandler = (e) => {
        isDragging = true;
        const wrapperRect = wrapper.getBoundingClientRect();
        offsetX = e.clientX - wrapperRect.left;
        offsetY = e.clientY - wrapperRect.top;
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
        e.stopPropagation();
      };

      field.addEventListener("mousedown", onMouseDownHandler);

      wrapper.appendChild(nameDiv);
      wrapper.appendChild(field);
      wrapper.appendChild(deleteIcon);
      wrapper.appendChild(editIcon);
      wrapper.appendChild(saveIcon);
      textLayerDiv.appendChild(wrapper);

      const fieldData = {
        id:fieldId,
        label,
        signatoryName: signatory.name,
        x: dropX,
        y: dropY + idx * 30,
        pageIndex: idx,
        saved: false,
      };

      newFields.push(fieldData);
    });

    setSignatureFields((prev) => [...prev, ...newFields]);
    if (setModePayload) setModePayload(null);
 }, [dropX, dropY, setModePayload]);


  return null;
};

export default EachPageEachSignatory;
